module.exports = __webpack_public_path__ + "static/media/testBook.a18ddf78.svg";